<template>
    <FullFillBox
        :pageID="1000"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
<!--        <div id="is-loading" style="display: block">-->
<!--            <MainPageLoadingView/>-->
<!--        </div>-->
<!--        <div id="is-real" style="display: none">-->
        <div v-if="is_loading === true">
            <MainPageLoadingView/>
        </div>
        <div v-else>
            <div class="top-card">
                <div class="row py-2">
                    <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                        <div class="card" style="width: 100%;height: 200px;background-color: rgba(75,208,255,0.69)">
                            <TopChartBox
                                :title="this.$t('main_title1')"
                                :getData="stock_in"
                                :getDataLastMon="stock_in_last_mon"
                                :subTitle="{'a': this.$t('main_kinds'),'b': 'PO','c': 'Qty'}"
                            />
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                        <div class="card" style="width: 100%;height: 200px;background-color: #f7ff00">
                            <TopChartBox
                                :title="this.$t('main_title2')"
                                :getData="stock_out"
                                :getDataLastMon="stock_out_last_mon"
                                :subTitle="{'a': this.$t('main_kinds'),'b': 'DN','c': 'Qty'}"
                            />
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                        <div class="card" style="width: 100%;height: 200px;cursor: pointer" @click="$router.push('/product/min-stock-lv')">
                            <div class="card card-block d-flex" style="height: 200px;text-align: center;background-color: rgba(255,128,0,0.56)">
                                <h5 style="margin-top: 15px">{{ $t('main_title3') }}</h5>
                                <div class="card-body align-items-center d-flex justify-content-center">
                                    <div class="row" style="width: 100%;">
                                        <div class="col-6 col-form-label"><h5>{{ $t('main_total_kinds') }}</h5></div>
                                        <div class="col-6"><h2 style="color: red">{{ min_stock }}</h2></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                        <div class="card" style="width: 100%;height: 200px;background-color: #cccccc;cursor: pointer" @click="$router.push('/system/online')">
                            <div class="card card-block d-flex" style="height: 200px;text-align: center;background-color: rgba(132,255,249,0.56)">
                                <h5 style="margin-top: 15px">{{ $t('main_title4') }}</h5>
                                <div class="card-body align-items-center d-flex justify-content-center">
                                    <h2 style="color: blue" v-if="count_user.currentOnlineUser < count_user.maxOnlineUser">
                                        {{ count_user.currentOnlineUser }} / {{ count_user.maxOnlineUser }} <span style="font-size: 20px;color: black"> {{ $t('main_ppl') }} </span>
                                    </h2>
                                    <h2 style="color: red" v-if="count_user.currentOnlineUser >= count_user.maxOnlineUser">
                                        {{ count_user.currentOnlineUser }} / {{ count_user.maxOnlineUser }} <span style="font-size: 20px;color: black"> {{ $t('main_ppl') }} </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="container">
                <div class="row">
                    <div class="col-12 py-lg-0 py-3">
                        <div class="card" style="background-color: #cccccc;">
                            <div class="card-body" style="text-align: center;">
                                <div>
                                    <h3>{{ $t('main_table_title1') }}</h3>
                                </div>
                                <div>
                                    {{ $t('main_from') }}
                                    <select v-model="ltpYearMonFrom" @change="ltpChange(1)">
                                        <option v-for="mon in year_mon_list" :value="mon">
                                            {{ mon }}
                                        </option>
                                    </select>
                                    {{ $t('main_to') }}
                                    <select v-model="ltpYearMon" @change="ltpChange(1)">
                                        <option v-for="mon in year_mon_list" :value="mon">
                                            {{ mon }}
                                        </option>
                                    </select>
                                    <span style="margin-left: 20px">
                                    <select v-model="ltpMode" @change="ltpChange(0)">
                                        <option value="all">{{ $t('main_all') }}</option>
                                        <option value="in">Stock In</option>
                                        <option value="out">Stock Out</option>
                                    </select>
                                </span>
                                    <span style="margin-left: 20px">
                                    <select v-model="ltpType" @change="ltpChange(1)">
                                        <option v-for="i in ltpTypeList" :value="i['key']">{{ i['value'] }}</option>
                                    </select>
                                </span>
                                </div>
                                <hr>
                                <div>
                                    <div v-if="ltpDataSet === null">
                                        <h3 style="height: 300px">{{ $t("common_no_data") }}</h3>
                                    </div>
                                    <div v-else>
                                        <div class="row">
                                            <div class="col-md-7 leftPart">
                                                <PieChartBox
                                                    :getDataSet="ltpDataSet"
                                                    getID="pie-chart-1"
                                                    :getHeight=300
                                                />
                                            </div>
                                            <div class="col-md-5 py-4 rightPart" style="text-align: center">
                                                <h6 style="text-align:left">{{ $t("main_menu_data_label") }}:</h6>
                                                <div class="row">
                                                    <div class="col-auto py-1" style="text-align:left" v-for="(color, index) in ltpColorList">
                                                        <svg style="width:15px;height:15px;display:inline;">
                                                            <rect id="box" stroke="black" :fill="color" x="0" y="0" width="15" height="15"/>
                                                        </svg>
                                                        <p style="display:inline;font-size: 10px">
                                                            &nbsp;:
                                                            {{ ltpDataSet['labels'][index] }}
                                                            ({{ ltpDataSet['datasets'][0]['data'][index] }})
                                                            {{ formatNumber(((ltpDataSet['datasets'][0]['data'][index])/ltpTotal)*100) }} %</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row py-lg-3 py-1">
                    <div class="col-lg-6 col-md-12">
                        <div class="card" style="background-color: #cccccc;">
                            <div class="card-body" style="text-align: center">
                                <h3>{{ $t('main_table_title2') }}</h3>
                                <p>
                                    <span style="color: #494949;font-size: 15px;margin-left: 10px">
                                        <select v-model="lblMode" @change="lblChange">
                                            <option value="inv">Inventory Stock</option>
                                            <option value="in">Stock In</option>
                                            <option value="out">Stock Out</option>
                                        </select>
                                        From
                                        <select v-model="lblYearMonFrom" @change="lblChange">
                                            <option v-for="mon in year_mon_list" :value="mon">
                                                {{ mon }}
                                            </option>
                                        </select>
                                        To
                                        <select v-model="lblYearMon" @change="lblChange">
                                            <option v-for="mon in year_mon_list" :value="mon">
                                                {{ mon }}
                                            </option>
                                        </select>
                                    </span>
                                </p>
                                <hr>
                                <div id="tabulatorTableUse" ref="tabulatorTableUse"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="card" style="background-color: #cccccc;">
                            <div class="card-body" style="text-align: center">
                                <h3>{{ $t('main_table_title3') }}
                                    <span style="color: #494949;font-size: 15px;margin-left: 10px">
                                    <select v-model="rblYear" @change="rblChange">
                                        <option v-for="year in year_list" :value="year">
                                            {{ year }}
                                        </option>
                                    </select>
                                    <select v-model="rblMode" @change="rblChange">
                                        <option value="in">Stock In</option>
                                        <option value="out">Stock Out</option>
                                    </select>
                                </span>
                                </h3>
                                <hr>
                                <div v-if="rblDataSet === null">
                                    <h3 style="height: 337px">{{ $t("common_no_data") }}</h3>
                                </div>
                                <div v-else>
                                    <LineChartBox
                                        :getDataSet="rblDataSet"
                                        getID="line-chart-1"
                                        :getHeight=337
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import LineChartBox from "@/components/charts/LineChartBox";
import PieChartBox from "@/components/charts/PieChartBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import MainPageLoadingView from "@/components/MainPageLoadingView";
import TopChartBox from "@/components/charts/TopChartBox";

export default {
    name: 'HomeView',
    components:{
        FullFillBox,
        LineChartBox,
        PieChartBox,
        MainPageLoadingView,
        TopChartBox,
    },
    data(){
        return {
            permissionDetails: {},
            is_loading: true,

            count_user: {},
            stock_in: {},
            stock_in_last_mon: {},
            stock_out: {},
            stock_out_last_mon: {},
            min_stock: 0,

            year_list: [],
            year_mon_list: [],

            // left top pie chart
            ltpDataSet: null,
            ltpYearMon: '',
            ltpYearMonFrom: '',
            ltpMode: 'in',
            ltpType: 'category',
            ltpColorList: [],
            ltpTotal: 0,
            ltpTypeList: [
                {
                    "key": "category",
                    "value": "Category"
                },
                {
                    "key": "brand",
                    "value": "Brand"
                },
                {
                    "key": "origin",
                    "value": "Origin"
                }
            ],

            // right bottom line chart
            rblDataSet: null,
            rblMode: 'in',
            rblYear: '',

            // left bottom line chart
            lblDataSet: null,
            lblYearMonFrom: '',
            lblYearMon: '',
            lblMode: 'in',
            lblTempDataSave: [],
        }
    },
    async mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('main_title')

        await this.getBackendData()

        let now = new Date()

        this.ltpYearMonFrom = now.getFullYear() + "-" + (now.getMonth() + 1)
        this.ltpYearMon = now.getFullYear() + "-" + (now.getMonth() + 1)
        this.rblYear = now.getFullYear()
        this.lblYearMonFrom = now.getFullYear() + "-" + (now.getMonth() + 1)
        this.lblYearMon = now.getFullYear() + "-" + (now.getMonth() + 1)

        let start_year = 2022
        let diff = now.getFullYear() - start_year
        for (let i = 0; i < diff + 1; i++) {
            this.year_list.push((start_year + i))
            for (let m = 1; m < 13; m++) {
                this.year_mon_list.push(((start_year + i)) + "-" + m)
            }
        }

        this.is_loading = false

        // tableSetup() do not have connection within API
        // no need to worry about the connection delay
        await this.tableSetup()

        // setTimeout(async () => {
        //     this.is_loading = false
        //     await this.tableSetup()
        // }, 1000)
    },
    methods:{
        tableSetup(){
            this.$nextTick(() => {
                this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
                    placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                    data: this.lblTempDataSave,
                    columns: [
                        {title: 'Rank', formatter: 'rownum', sorter: 'number', resizable:false,
                            width:80, responsive:0,
                        },
                        {title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable:false,
                            responsive:0, widthGrow: 3,
                        },
                        {title: 'ctn', field: 'ctn', sorter: 'number', resizable:false,
                            responsive:0, widthGrow: 1,
                        },
                        {title: 'packing', field: 'packing', sorter: 'number', resizable:false,
                            responsive:0, widthGrow: 1,
                        },
                    ],
                    reactiveData: true, //enable data reactivity
                    maxHeight: '280px',
                    height: '280px',
                    responsiveLayout: 'collapse',
                    layout: "fitColumns",
                    movableColumns:true,
                    movableRows: false,
                })
            })

        },
        async lblChange() {
            await this.$mainApi.get(`api/inventory/left-bot-line?from=${this.lblYearMonFrom}&to=${this.lblYearMon}&mode=${this.lblMode}`)
                .then(response => {
                    if (response.data.status === 80) {
                        this.lblSetup(response.data.details)
                    }
                })
        },
        async lblSetup(getData){
            this.tabulator.setData(getData)
            this.tabulator.redraw()
        },
        async rblChange() {
            await this.$mainApi.get(`api/inventory/right-bot-line?date=${this.rblYear}&mode=${this.rblMode}`)
                .then(response => {
                    if (response.data.status === 80) {
                        this.rblSetup(response.data.details)
                    }
                })
        },
        async rblSetup(getData){
            if(getData.length === 0){
                this.rblDataSet = null
            }else{
                this.rblDataSet = {
                    labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec',],
                    datasets: [
                        {
                            label: 'product',
                            borderColor: '#f87979',
                            backgroundColor: '#f87979',
                            data: [
                                getData[0]['product'],
                                getData[1]['product'],
                                getData[2]['product'],
                                getData[3]['product'],
                                getData[4]['product'],
                                getData[5]['product'],
                                getData[6]['product'],
                                getData[7]['product'],
                                getData[8]['product'],
                                getData[9]['product'],
                                getData[10]['product'],
                                getData[11]['product'],
                            ]
                        },
                        {
                            label: 'key',
                            borderColor: '#fcba03',
                            backgroundColor: '#fcba03',
                            data: [
                                getData[0]['key'],
                                getData[1]['key'],
                                getData[2]['key'],
                                getData[3]['key'],
                                getData[4]['key'],
                                getData[5]['key'],
                                getData[6]['key'],
                                getData[7]['key'],
                                getData[8]['key'],
                                getData[9]['key'],
                                getData[10]['key'],
                                getData[11]['key'],
                            ]
                        },
                        {
                            label: 'sumQty',
                            borderColor: '#32a852',
                            backgroundColor: '#32a852',
                            data: [
                                getData[0]['sumQty'],
                                getData[1]['sumQty'],
                                getData[2]['sumQty'],
                                getData[3]['sumQty'],
                                getData[4]['sumQty'],
                                getData[5]['sumQty'],
                                getData[6]['sumQty'],
                                getData[7]['sumQty'],
                                getData[8]['sumQty'],
                                getData[9]['sumQty'],
                                getData[10]['sumQty'],
                                getData[11]['sumQty'],
                            ]
                        }
                    ]
                }
            }
        },
        ltpSetup(getData){
            let total_all_qty = 0
            let label_use = []
            let data_use = []
            if (getData.length === 0) {
                this.ltpDataSet = null
            }else{
                let color = this.getRandomColor(getData.length)
                for(let i=0;i<getData.length;i++){
                    label_use.push(getData[i]['keyName'])
                    data_use.push(getData[i]['sumQty'])
                    total_all_qty = total_all_qty + getData[i]['sumQty']
                }
                let pie_chart_data = {
                    labels: label_use,
                    datasets: [
                        {
                            data: data_use,
                            backgroundColor: color,
                        }
                    ]
                }
                this.ltpColorList = color
                this.ltpDataSet = pie_chart_data
                this.ltpTotal = total_all_qty
            }
        },
        async ltpChange(flag){
            // 0 => update Type
            if(flag === 0){
                if(this.ltpMode === 'all'){
                    this.ltpTypeList = [
                        {
                            "key": "category",
                            "value": "Category"
                        },
                        {
                            "key": "brand",
                            "value": "Brand"
                        }
                    ]
                }
                if(this.ltpMode === 'in'){
                    this.ltpTypeList = [
                        {
                            "key": "category",
                            "value": "Category"
                        },
                        {
                            "key": "brand",
                            "value": "Brand"
                        },
                        {
                            "key": "origin",
                            "value": "Origin"
                        }
                    ]
                }
                if(this.ltpMode === 'out'){
                    this.ltpTypeList = [
                        {
                            "key": "category",
                            "value": "Category"
                        },
                        {
                            "key": "brand",
                            "value": "Brand"
                        },
                        {
                            "key": "department",
                            "value": "Department"
                        },
                        {
                            "key": "driver",
                            "value": "Driver"
                        }
                    ]
                }
                this.ltpType = "category"
            }
            await this.$mainApi.get(`api/inventory/left-top-pie?from=${this.ltpYearMonFrom}&to=${this.ltpYearMon}&mode=${this.ltpMode}&type=${this.ltpType}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.ltpSetup(response.data.details)
                    }
                })
        },
        async getBackendData(){
            await this.$mainApi.get('api/inventory/main/')
                .then(response=>{
                    if(response.data.status === 80){
                        this.count_user = response.data.details.count_user
                        this.stock_in = response.data.details.stock_in
                        this.stock_in_last_mon = response.data.details.stock_in_last_mon
                        this.stock_out = response.data.details.stock_out
                        this.stock_out_last_mon = response.data.details.stock_out_last_mon
                        this.min_stock = response.data.details.min_stock
                        this.ltpSetup(response.data.details.leftTop_pie)
                        this.rblSetup(response.data.details.rightBot_line)
                        this.lblTempDataSave = response.data.details.leftBot_line
                    }
                })
        },
        formatNumber (num) {
            return parseFloat(num).toFixed(2)
        },
        getRandomColor(loop) {
            let newColorList = []
            while(newColorList.length !== loop){
                const letters = '0123456789ABCDEF'.split('');
                let color = '#';
                for (let i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                if(!newColorList.includes(color)){
                    newColorList.push(color)
                }
            }
            if(newColorList.length > 0){
                this.colorList = newColorList
            }
            return newColorList;
        }
    }
}
</script>
